import React from 'react';
import {PlaceApi} from "../../../../../../services/Api/types";
import {ReactComponent as ClockIco} from "../../../../../../../images/icons/clock.svg";
import HoursHelper from "../../../../../../services/Menu/services/Availability/HoursHelper";
import DateService from "../../../../../../services/Common/Date/DateService";
import {useTranslation} from "react-i18next";

interface Props {
    place: PlaceApi;
}

const MultistorePlaceCardFooter = ({place}: Props) => {
    const {t} = useTranslation();
    const hours = place.hours || [];
    const isOpen = HoursHelper.isOpen(hours, DateService.now());
    const openingInfo = HoursHelper.getNextOpening(hours, DateService.now(), t);
    const isPaused = place.status === "PAUSED";

    return (
        <div className="place-card-footer">
            {hours.length > 0 && !isPaused && (
                <div className="place-card-footer-row">
                    <ClockIco className={`${isOpen ? "text-success" : "text-danger"}`}/>
                    <p className={`${isOpen ? "text-success" : "text-danger"} mb-0`}>{openingInfo}</p>
                </div>
            )}
            {
                isPaused && (
                    <div className="place-card-footer-row">
                        <ClockIco className="text-warning"/>
                        <p className="text-warning mb-0">{t("common.word.temporarily_close")}</p>
                    </div>
                )
            }
        </div>
    )
}

export default MultistorePlaceCardFooter;